import script from "./details.vue?vue&type=script&setup=true&lang=ts"
export * from "./details.vue?vue&type=script&setup=true&lang=ts"

import "./details.vue?vue&type=style&index=0&id=94d52f7a&lang=less&scoped=true"

import exportComponent from "/Users/zllword/zongxueguan/project/verite-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d52f7a"]])

export default __exports__